module.exports = __webpack_public_path__ + "assets/img/1.8726ddf8.png";